/**
 * The scenes share the brand's palette — basalt, charcoal, bone, brass — warmed up with the kind of
 * low evening light a stone showroom is lit with. The stone itself is never painted here: it comes
 * from the catalogue.
 */
export const PAL = {
  // walls and joinery
  wall: '#2b2927',
  wallHi: '#3a3733',
  wallLo: '#1c1b1a',
  plaster: '#34312e',
  cabinet: '#25272b',
  cabinetHi: '#31343a',
  cabinetLo: '#17181b',
  cabinetEdge: '#454952',
  plinth: '#0d0e10',
  ceiling: '#1a1918',
  // metals and light
  brass: '#b8975a',
  brassHi: '#e6d09a',
  brassLo: '#7a5f31',
  steel: '#8b9097',
  steelLo: '#3a3d42',
  bone: '#f4efe6',
  boneDim: '#cfc7b8',
  warm: '#ffd9a1',
  warmHot: '#ffbf73',
  daylight: '#e6eef2',
  // living things
  leaf: '#2e4a38',
  leafHi: '#4d7358',
  leafLo: '#1f3326',
  pot: '#c8b998',
  potLo: '#9a8b6c',
  wood: '#8a6a45',
  woodHi: '#b08a5c',
  woodLo: '#5b4529',
  // the plain matte surface the stone is compared with ("before")
  matte: '#8a857c',
  matteLo: '#6f6b64',
} as const;
